
(function (window, document, jQuery, undefined) {
    // map jQuery to local var
    var $ = jQuery.noConflict();
    var $steps = $('.don-progress-steps');
    $(window).on("load resize scroll", function (e) {
        $steps.each(function () {
            if (inView.is(this)) {
                $(this).addClass('is-in-view');
            }
        })
    });

})(window, document, jQuery);
